import React, { Fragment } from "react";
import NavbarSubMenu from "../../components/NavbarSubMenu/NavbarSubMenu";
import PageTitle from "../../components/pagetitle/PageTitle";
import Contactpage from "../../components/Contactpage/Contactpage";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const ContactPage = () => {
  return (
    <Fragment>
      <NavbarSubMenu />
      <PageTitle pageTitle={"Contact Us"} pagesub={"Contact"} />
      <Contactpage />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ContactPage;
